import React from "react";
import { useExtraDetails } from "@/hooks/useExtraDetails";
import { Switch } from "@/components/ui/switch";

const ExtraDetailsToggle = () => {
  const { showExtraDetails, toggleExtraDetails } = useExtraDetails();

  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-gray-600">
        {showExtraDetails ? "On" : "Off"}
      </span>
      <Switch
        checked={showExtraDetails}
        onCheckedChange={toggleExtraDetails}
        aria-label="Toggle extra details display"
        data-gtm-element-id="dashboard_extra_details_toggle"
      />
    </div>
  );
};

export default ExtraDetailsToggle;
